import { LimitTypes } from '../customLimitsTypes';

export const assignLimitsUnits = (
  limitType: LimitTypes,
  usage: number | string
): number | string => {
  switch (limitType) {
    case 'storage':
      return `${usage.toLocaleString()} GB`;

    default:
      return usage.toLocaleString();
  }
};
